import { Link } from 'react-router-dom';
import { movies } from '@/mocks/movies';

const allMovies = [...movies].sort((a, b) => b.viewCount - a.viewCount);

export default function RankingSection() {
  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="mb-8">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-[var(--font-heading)]">
            热门排行
          </h2>
          <p className="text-sm text-foreground-500 mt-1">根据观看热度实时更新</p>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          {allMovies.slice(0, 10).map((movie, index) => (
            <Link
              key={movie.id}
              to={`/article/${movie.id}`}
              className="group flex items-center gap-4 p-3 rounded-lg hover:bg-background-100 transition-colors cursor-pointer"
            >
              <div className="flex-shrink-0 w-10 h-10 md:w-12 md:h-12 flex items-center justify-center">
                {index < 3 ? (
                  <span
                    className={`w-8 h-8 flex items-center justify-center rounded-full text-sm font-bold text-background-50 ${
                      index === 0
                        ? 'bg-red-500'
                        : index === 1
                          ? 'bg-orange-500'
                          : 'bg-amber-500'
                    }`}
                  >
                    {index + 1}
                  </span>
                ) : (
                  <span className="text-lg font-bold text-foreground-300">{index + 1}</span>
                )}
              </div>

              <div className="flex-shrink-0 w-12 h-16 rounded overflow-hidden">
                <img
                  src={movie.posterUrl}
                  alt={movie.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>

              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-medium text-foreground-900 group-hover:text-accent-600 transition-colors line-clamp-1">
                  {movie.title}
                </h3>
                <div className="flex items-center gap-2 mt-1">
                  <span className="text-xs text-foreground-500">{movie.year}</span>
                  <span className="text-xs text-foreground-400">·</span>
                  <span className="text-xs text-foreground-500">{movie.category}</span>
                  <span className="text-xs text-foreground-400">·</span>
                  <span className="text-xs text-accent-600 font-medium">{movie.rating}分</span>
                </div>
              </div>

              <div className="flex-shrink-0 text-right">
                <span className="text-xs text-foreground-400">
                  {(movie.viewCount / 10000).toFixed(0)}万人观看
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}